/**
 * @generated SignedSource<<1f5e0c854c1593e1843595a406a451a4>>
 * @relayHash 4c07900d149436b6a44a96b188f8b5e0
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4c07900d149436b6a44a96b188f8b5e0

import { ConcreteRequest } from 'relay-runtime';
export type DeleteAppointmentInput = {
  id: string;
};
export type useDeleteAppointmentMutation$variables = {
  connections: ReadonlyArray<string>;
  deleteAppointment: DeleteAppointmentInput;
};
export type useDeleteAppointmentMutation$data = {
  readonly deleteAppointment: {
    readonly appointment: {
      readonly appointmentId: number;
      readonly id: string;
    } | null;
  };
};
export type useDeleteAppointmentMutation = {
  response: useDeleteAppointmentMutation$data;
  variables: useDeleteAppointmentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "deleteAppointment"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "deleteAppointment"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appointmentId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useDeleteAppointmentMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "DeleteAppointmentPayload",
        "kind": "LinkedField",
        "name": "deleteAppointment",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Appointment",
            "kind": "LinkedField",
            "name": "appointment",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "useDeleteAppointmentMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "DeleteAppointmentPayload",
        "kind": "LinkedField",
        "name": "deleteAppointment",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Appointment",
            "kind": "LinkedField",
            "name": "appointment",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteEdge",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id",
                "handleArgs": [
                  {
                    "kind": "Variable",
                    "name": "connections",
                    "variableName": "connections"
                  }
                ]
              },
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "4c07900d149436b6a44a96b188f8b5e0",
    "metadata": {},
    "name": "useDeleteAppointmentMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "54a634198c8895f04315494b0f7f0f92";

export default node;
